// extracted by mini-css-extract-plugin
module.exports = {"aller_toast":"confirmButton_aller_toast___nsWU","delete_button":"confirmButton_delete_button__2kXY7"};